import { createApp } from 'vue'
import App from './App.vue'

import 'vue-fullpage.js/dist/style.css'
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'
import "@/assets/css/animate.css";
import beforeEach from './router/beforeEach'
import store from './store'
const app = createApp(App)
import VueParticles from 'vue-particles'



import i18n from '@/i18n/index.js'
app.use(i18n)


app.use(store)
app.use(beforeEach)
app.use(VueFullPage)
app.use(VueParticles)
app.mount('#app')
